/**
 * Helper function to determine whether the URL that will be redirected to is on the same host.
 */
export const isOnCurrentHost = (redirectURL: string): boolean => {
  // we assume URL to be protocol-relative
  const redirectURLObj = new URL(redirectURL);

  if (redirectURLObj.hostname === window.location.hostname) return true;
  return false;
};
